export default __webpack_public_path__ + "static/media/trend_up.c5cbe11a.svg";